import React from 'react';
import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getInventoryLevelsFilteredData } from '../services/inventoryLevelsServices';

export default function FilterModal({onClose , data }) {
    const { t } = useTranslation();
    const dispatch =useDispatch();
    const toast = useToast({position: "top", duration: 3000, status: "success", });

    const [filteredData, setFilteredData] = useState(data);

    // Filter Data
    const [filterCriteria, setFilterCriteria] = useState({
        BranchName: "",
        CostAdjustmentRef: "",
        CostAdjustmentStatus: "",
        LowLevelOnly: "",
        CostingMethod: ""
      });

      const handleFilterInventoryLevels = (e) => {
        e.preventDefault();
    
        const filteredResult = data.filter((item) => {
          const { Items , LowLevelOnly , CostingMethod} = filterCriteria;
    
          let filterItems = true;
          let filterLowLevelOnly = true;
          let filterCostingMethod = true;
    
    
          if (Items) {
            filterItems = item?.InventoryItemNameEng?.toLowerCase().includes(Items.toLowerCase());
          }


          if (LowLevelOnly) {
            filterLowLevelOnly = item?.LowLevelOnly.toLowerCase().includes(LowLevelOnly.toLowerCase());
          }

          if (CostingMethod) {
            filterCostingMethod = item?.CostingMethod.toLowerCase().includes(CostingMethod.toLowerCase());
          }

          return (
            filterItems &&
            filterLowLevelOnly &&
            filterCostingMethod
          );

        });
    
        setFilteredData(filteredResult);
        onClose();
        dispatch(getInventoryLevelsFilteredData(filteredResult));
      };

  return <>
  
  <GModal
      onClose={onClose}
      modalHeader={t("pages.reports.inventory_reports.inventory_levels")}
      modalContent={
        <Box p={4}>
          <form 
            onSubmit={handleFilterInventoryLevels}
          >
            <Stack spacing={6}>

              <Input
                label={t("pages.reports.reports_tables.items")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.reports.reports_tables.items")}
                name="Items"
                value={filterCriteria.Items}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    Items: e.target.value,
                  })
                }
              />

              <Input
                label={t("pages.reports.reports_tables.low_level_only")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.reports.reports_tables.low_level_only")}
                name="LowLevelOnly"
                value={filterCriteria.LowLevelOnly}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    LowLevelOnly: e.target.value,
                  })
                }
              />

              <Input
                label={t("pages.reports.reports_tables.costing_method")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.reports.reports_tables.costing_method")}
                name="CostingMethod"
                value={filterCriteria.CostingMethod}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    CostingMethod: e.target.value,
                  })
                }
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  
  </>
};